import React from 'react';

import { strings } from 'APP_ROOT/localization';
import LambdaUtil from 'APP_ROOT/components/aws/lambda/lambdaUtil';
import Events from 'APP_ROOT/components/common/events';
import Validation from 'APP_ROOT/components/common/validation';
import { TAG_USER_ROLES } from '../../../../data/tags';
import TagRolesDropDown from "../../../TagRolesDropDown"

import RescindSharedRavenAccessModal from 'APP_ROOT/components/pages/account/rescindSharedRavenAccessModal';

export default class OwnerUserAccessPage extends React.PureComponent {

    state = {
        emailValid: null,
        selectedRole: TAG_USER_ROLES.GUEST,
        selectedTag: "All",
        errorMessage: null
    }

    onRoleChange = (e) => {
        this.setState({selectedRole: e.target.value});
    }

    onShareSubmit = (e) => {

        e.preventDefault();
        if (this.validateForm()) {
            document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.raven_invite_sending, this.shareTargetEmail.value) } }));
            LambdaUtil.inviteUser(this.props.user.stage, this.state.selectedTag, this.state.selectedRole, this.shareTargetEmail.value, this.onShareSuccess, this.onShareFail);
            this.setState({
                emailValid: true,
                errorMessage: null
            });
        } else {
            this.setState({
                emailValid: false,
                errorMessage: strings.please_provide_a_valid_email_address
            });
        }
    }

    validateForm() {

        if (Validation.validateEmail(this.state.emailValid, this.shareTargetEmail.value, true)) {
            return true;
        }
        return false;
    }

    onShareSuccess = (data) => {
        var payload = JSON.parse(data.Payload);
        if (payload.status === 'ERROR') {
            this.genericError(data);
            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
            return;
        } else {
            document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.raven_invite_sent, this.shareTargetEmail.value), style: 'success', 'override': true } }));
            setTimeout(() => {
                window.location.reload();
            }, 2000);
            return;
        }
    }

    onShareFail = (data) => {

        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
        this.genericError(data);
    }

    genericError(data) {

        if (data) console.error(data);
        this.setState({
            errorMessage: strings.formatString(strings.raven_invite_send_error)
        })
    }

    openRescindAccessModal = (e, user) => {

        e.preventDefault();
        document.documentElement.classList.add("no-scroll");

        var rescindAccessModalOpen = this.state.rescindAccessModalOpen;
        if(!rescindAccessModalOpen) { rescindAccessModalOpen = {} }
        rescindAccessModalOpen[user.email] = true;

        this.setState({
            rescindAccessModalOpen: rescindAccessModalOpen,
            rescindUser: user
        });
    }

    closeRescindAccessModal = (e, user) => {

        e.preventDefault();
        document.documentElement.classList.remove("no-scroll");

        var rescindAccessModalOpen = this.state.rescindAccessModalOpen;
        if(!rescindAccessModalOpen) { rescindAccessModalOpen = {} }
        rescindAccessModalOpen[user.email] = false;

        this.setState({
            rescindAccessModalOpen: rescindAccessModalOpen,
            rescindUser: null
        });
    }

    getSortedUserList(userList) {
        const sortedRavenUsers = [];

        userList.forEach(user => {
            const isOwner = user.accessLevel && user.accessLevel.toLowerCase() === 'owner';
            if (isOwner) {
                sortedRavenUsers.unshift(user);
            } else {
                sortedRavenUsers.push(user);
            }
        });
            
        return sortedRavenUsers;
    }

    render() {
        const { selectedRaven } = this.props;

        // Set the initial user list to blank
        let userList = <p>{strings.formatString(strings.mo_users_no_additional, selectedRaven.vehicle.name ? selectedRaven.vehicle.name : "")}</p>;

        // If there are raven Users, populate the list
        if(selectedRaven.ravenUsers)
        {
            const sortedRavenUsers = this.getSortedUserList(selectedRaven.ravenUsers);            

            userList = sortedRavenUsers.map((user, index) => {
                var driverName = user.driverName ? user.driverName : '';
                var email = user.email ? user.email : strings.unknown_user;
                email = driverName === email ? null : email;

                const isOwner = user.accessLevel && user.accessLevel.toLowerCase() === 'owner';

                return (
                    <div className="user-item row" key={index}>
                        <div className="col-12 col-sm-8">
                            <i className="material-icons blue icon-sm">person</i>
                            {driverName === '' ? email : driverName}
                            <p>{email}</p>
                        </div>
                        <div className="col-12 col-sm-4 btn-row">
                            {!isOwner && <a className="btn btn-outline-blue btn-sm" onClick={(e) => this.openRescindAccessModal(e, user)}><i className="material-icons">remove_circle_outline</i>{strings.formatString(strings.remove_access)}</a>}
                        </div>
                        <RescindSharedRavenAccessModal {...this.props} {...this.state}
                            raven={selectedRaven}
                            closeRescindAccessModal={(e) => this.closeRescindAccessModal(e, user)}
                            rescindAccessModalOpen={this.state.rescindAccessModalOpen && this.state.rescindAccessModalOpen[email]}
                            email={email} />
                    </div>
                );
            })
        }

        return (
            <div className="mobile-users-page container">
                <div className="row">
                    <div className="col-12">
                        <h2><i className="material-icons">supervised_user_circle</i> {strings.formatString(strings.trusted_circle_title)}</h2>
                    </div>
                    <div className="col-12 shared-user-list">
                        {userList}
                    </div>
                    <div className="col-12">
                        <h3>{strings.formatString(strings.invite_user)}</h3>
                    </div>
                    <div className="col-12 col-sm-7 col-md-6 col-lg-4">
                        <input type="email" ref={ref => { this.shareTargetEmail = ref }} placeholder="eg. user@raven.is" />
                    </div>
                    <div className="col-12 col-sm-3 col-md-4 col-lg-4">
                        <TagRolesDropDown
                            showOptionForAll={false}
                            value={this.state.selectedRole}
                            onChange={this.onRoleChange}
                        />
                    </div>
                    <div className="col-12 col-sm-2 col-md-2 text-right">
                        <button className="btn btn-secondary" onClick={this.onShareSubmit}>
                            <i className="material-icons">email</i> {strings.formatString(strings.users_invite_action)}
                        </button>
                    </div>
                    <div className="col-12 info-section">
                        {this.state.emailValid === false ?
                                <p className="error-message">{this.state.errorMessage}</p> : null
                        }
                        <p>{strings.formatString(strings.mo_users_m1)}</p>
                        <p>{strings.formatString(strings.mo_users_m2)}</p>
                    </div>
                </div>
            </div>
        );
    }
}
